import { useContext } from 'react';
import { ScrollingContainerRefContext } from './scrolling-container-ref-context';

export function useScrollingContainer() {
  const containerRef = useContext(ScrollingContainerRefContext);
  return { ref: containerRef };
}
